import type { PublicStage, PublicTask } from "@/services/public-view.service";

export type RoadmapBucket = "now" | "next" | "done";

export const ROADMAP_BUCKETS: {
	key: RoadmapBucket;
	title: string;
	hint: string;
}[] = [
	{ key: "now", title: "Working on now", hint: "The team is actively on these" },
	{ key: "next", title: "Coming up next", hint: "Planned, not started yet" },
	{ key: "done", title: "Done", hint: "Finished, most recent first" },
];

// ponytail: stages are custom per project with no category column, so buckets
// come from well-known keys. Unknown stages count as "now" (they sit between
// to do and done in every workflow seen so far). Add a stage category if not.
const NEXT_KEYS = new Set(["backlog", "todo", "to-do", "to_do"]);
const DONE_KEYS = new Set(["done", "completed"]);

export function bucketOf(status: string): RoadmapBucket {
	if (DONE_KEYS.has(status)) return "done";
	if (NEXT_KEYS.has(status)) return "next";
	return "now";
}

// Plain-language names for dev stages shown on "now" cards.
const FRIENDLY_STAGE: Record<string, string> = {
	"in-progress": "Being built",
	in_progress: "Being built",
	qa: "Testing",
	review: "Being reviewed",
	in_review: "Being reviewed",
	blocked: "On hold",
};

export function friendlyStage(status: string, stage?: PublicStage) {
	return FRIENDLY_STAGE[status] ?? stage?.name ?? status;
}

export function groupByBucket(tasks: PublicTask[]) {
	const groups: Record<RoadmapBucket, PublicTask[]> = { now: [], next: [], done: [] };
	for (const t of tasks) {
		if (t.status === "cancelled") continue;
		groups[bucketOf(t.status)].push(t);
	}
	return groups;
}
